import { updateFooterLinks } from "./updateFooterLinks";
import { attachNextPrevClickEvent } from "./attachNextPrevClickEvent";
import { attachSearchEvent } from "./attachSearchEvent";
import { createArticleList } from "./createArticleList";
import { getCurrentContext } from "./getCurrentContext";
import { initPagination } from "./initPagination";
import {blogs} from './globalObj'
// import { start_loader, stop_loader} from "../util";

/**
 * Get All Blogs
 */

export function getAllBlogs(g2CollectionURL: any){
    /*To show the loader only in online scheduler flow so commenting the loader [+57326] 
    start_loader();
    */
    $.ajax({
        type: 'GET',
        url: g2CollectionURL,
        dataType: 'json',
        headers : {'Accept-Encoding': 'gzip'},
        async: true,
        cache: false,
        success: function (data:any){
            var allBlogs = data.response.docs;
            // Update Footer Links
            updateFooterLinks(allBlogs);
            // attach click event only if links are enabled.
            attachNextPrevClickEvent();
            // stop_loader();
            if(window.location.href.toLowerCase().indexOf("/search/") == -1)
            {
            blogs.count = data.response.numFound;
             $('.blog-section div').remove();
             createArticleList(allBlogs);
             initPagination(blogs.count);
             attachSearchEvent();
		     getCurrentContext();
            }
            
        },
        error: function (e: any){
            // stop_loader();
            console.log(e.message);
        }
    });
}
